export enum FontSizePreference {
    Invalid = 0,
    PX12 = 12,
    PX14 = 14,
    PX16 = 16,
    PX18 = 18,
    PX20 = 20,
    PX22 = 22,
    PX24 = 24,
}

